module.exports = __webpack_public_path__ + "img/cross.2e5bfe1a.svg";